import { AsyncLocalStorage } from 'async_hooks'

const asyncLocalStorageObject = AsyncLocalStorage ? new AsyncLocalStorage() : {}

export default asyncLocalStorageObject
export { asyncLocalStorageObject }
